var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBackButtonContactStepMobile = function SvgBackButtonContactStepMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.862 15.805L3.057 8 10.862.195l.942.943L4.943 8l6.861 6.862-.942.943z",
    fill: "#333"
  })));
};
export default SvgBackButtonContactStepMobile;